const Footer = () => {
  return (
    <div className="w-screen flex justify-center items-center p-8 border-t-2 mt-6">
      <div className="flex flex-col">
        <div className="flex flex-col text-left">
            <h3 className="font-bold mb-1">Copyright Notice</h3>
            <p className="text-[0.75rem] text-wrap">
              Copyright © 2024, Ford Motor Company. All rights reserved. 
              All text, images, graphics, animation, videos, music, sounds, and 
              other materials on this website ("site") are subject to the copyrights and 
              other intellectual property rights of Ford Motor Company, 
              its affiliated companies, and its licensors. Ford Motor Company owns the copyrights in the selection, 
              coordination, and arrangement of the materials on this site. 
              These materials may not be copied for commercial use or distribution, 
              nor may these materials be modified or reposted to other sites.
            </p>
          </div>
          <div className="flex flex-col text-left">
            <h3 className="font-bold mt-1">Confidentiality Notice</h3>
            <p className="text-[0.75rem] text-wrap">
                The information contained on this website is Confidential and may not be distributed without prior approval of the Ford Motor Company. 
                User agrees to keep confidential any and all information, documents and/or records whatsoever accessed from this site.
            </p>
          </div>
        </div>
    </div>
  )
}

export default Footer
